module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-横幅关闭.e2cf1.png";